import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import SystemDetail from "@/pages/SystemDetail";

import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminSystemList from "@/pages/admin/AdminSystemList";
import AdminSystemEdit from "@/pages/admin/AdminSystemEdit";
import AdminLeads from "@/pages/admin/AdminLeads";

function PublicShell({ children }) {
  const { pathname } = useLocation();
  const hideChrome = pathname.startsWith("/admin");
  if (hideChrome) return children;
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PublicShell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/systems/:slug" element={<SystemDetail />} />

            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminOverview />} />
              <Route path="systems" element={<AdminSystemList />} />
              <Route path="systems/:id" element={<AdminSystemEdit />} />
              <Route path="leads" element={<AdminLeads />} />
            </Route>
          </Routes>
        </PublicShell>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
